import QuestionViewModal from "modules/question-bank/questionViewmodal";
import React, { useCallback, useEffect, useState, useContext } from "react";
import { apiPaths, deleteData, deleteInstituteAppData, getAdminData, getData, getInstutueApp, postData, postInstituteAppData } from "../platform-components/api-integration-util";
import Grid from "../platform-components/grid/Grid";
import { getRoleNameList, getUserDetails } from "../platform-components/utils/shared-data.service";
import Moment from "moment";
import moment from 'moment';
import { Box, Card, CardContent, IconButton, Typography, Button, Dialog, DialogContent, DialogContentText, DialogActions, TextField, FormControlLabel, Checkbox, Modal } from "@mui/material";
import { ViewList } from "@material-ui/icons";
import { useStyles } from "modules/classes/style";
import SearchQB from "modules/platform-components/search-qb/searchQB";
import { AppContext } from "context/AppContext";
import { DialogTitle, Grid as Gd } from "@material-ui/core";
import noData from "images/no-data.jpg";
import DeleteIcon from '@mui/icons-material/Delete';
import { Toaster } from "../platform-components/Toaster";
import { toast } from "react-toastify";
import AddQuestion from "modules/dashboard/AddQuestion";
import AddQbQuestion from "./addQbQuestion";
import CloseIcon from '@mui/icons-material/Close';
import "./qb.scss"
import noImage from "images/nosubimg.png";


const Qb = () => {
  const [qbData, setQbData] = useState([]); // Store QB data
  const [loading, setLoading] = useState(true);
  const [QBCount, setQBCount] = useState(0); // Define QBCount
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);
  const [questionDataList, setQuestionDataList] = useState([]); // Store question data
  const [questionData, setQuestionData] = useState({}); // Store question data
  const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(-1);
  const [selectedQuestionEditable, setSelectedQuestionEditable] = useState(null); // Define selectedQuestionEditable
  const classes = useStyles();
  const [currentView, setCurrentView] = useState("tab");
  const [currentViewShowing, setCurrentViewShowing] = useState("subject");
  let [displayCharts, setDisplayCharts] = useState(false);
  const { subjects, userSubjectMap } = useContext(AppContext);
  const [filteredSubject, setFilteredSubject] = useState([]);
  const [selectedTopicsList, setSelectedTopicsList] = useState([]);
  const [open, setOpen] = useState(false);
  const [deletedQnId, setDeletedQnId] = useState()
  const [openAddQnModal, setOpenAddQnModal] = useState(false);
  const [selectedQBModuleId, setSelectedQBModuleId] = useState(false);
  const [questionId, setQuestionId] = useState()
  const [libraryQBModuleId, setLibraryQBModuleId] = useState()
  const [addedQuestionId, setAddedQuestionId] = useState()
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [includeExplanation, setIncludeExplanation] = useState(false);
  const [includeAnswer, setIncludeAnswer] = useState(false);
  const [includeQuestion, setIncludeQuestion] = useState(false);


  useEffect(() => {
    let role = getRoleNameList();
    if (userSubjectMap && userSubjectMap.length && subjects && subjects.length && (role.includes('Academic Cordinator') || role.includes('Admin'))) {
      setFilteredSubject(subjects);
    } else if (userSubjectMap && userSubjectMap.length && subjects && subjects.length) {
      const userId = getUserDetails()?.userId;
      const availableSubjects = userSubjectMap.filter(subject => subject.userId == userId).map(subject => subject.subjectId);
      setFilteredSubject(subjects.filter(sub => availableSubjects.indexOf(sub.subjectId) !== -1));
    }
  }, [userSubjectMap, subjects])

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const userDetails = getUserDetails();
      // Fetch QB data
      const response = await getAdminData(apiPaths.getLibraryQB);
      setQbData(response.result);
    } catch (error) {
      console.error("Error fetching QB data:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleQuestionClick = (libraryQBModuleId) => {
    setLibraryQBModuleId(libraryQBModuleId)
    setSelectedQBModuleId(libraryQBModuleId);
    // Handle click on a question
    // Fetch question data for the clicked question ID and set it in state
    getAdminData(`${apiPaths.getQuestionIdsByQB}?libraryQBId=${libraryQBModuleId}`).then((response) => {
      if (response.result) {
        setQuestionDataList([]);
        setQuestionDataList(response.result);
        setQBCount(response.result.length);
      }
    });
  };

  const handleQuestionIdClick = (questionId) => {
    const clickedIndex = questionDataList.indexOf(questionId);
    console.log('clickedIndex: ', clickedIndex);

    setSelectedQuestionIndex(clickedIndex);
    setSelectedQuestionId(questionId);

    // Fetch question data for the clicked question ID
    getData(apiPaths.questionbyid + `?id=${questionId}`).then((response) => {
      if (response.result) {
        setQuestionData(response.result);
      }
    });

  };

  const link = (params) => {
    return (
      <div className="text-link" onClick={() => handleQuestionClick(selectedTopicsList[params.rowIndex].libraryQBModuleId)}>
        {params?.value}
      </div>
    );
  };
  const button = (params) => {
    return (
      <div>
        <IconButton className="delete-icon" style={{ padding: "0px", marginLeft: "10px" }} aria-label="delete" onClick={() => { handleClickOpen(params) }}>
          <DeleteIcon />
        </IconButton>
      </div>
    );
  };

  const qIDlink = (params) => {
    return (
      <div className="text-link" onClick={() => handleQuestionIdClick(params.value)}>
        {params?.value}
      </div>
    );
  };

  const handleClickOpen = (data) => {
    setDeletedQnId(data.data)
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDeleteQuestion = async () => {

    const response = await deleteInstituteAppData(apiPaths.deleteQuestionFromQB, {
      data: [],
      params: {
        questionId: deletedQnId,
        libraryQBModuleId: libraryQBModuleId
      },
      headers: {
        tenantId: getUserDetails().tenantId,
        userEmail: getUserDetails().email,
      },

    })
    handleClose()
    if (response.result == true) {
      Toaster(toast.TYPE.SUCCESS, "Question deleted Successfully");
      refreshTopicQuestions();
    } else {
      Toaster(toast.TYPE.ERROR, "Error in deleting question");
    }
  }
  const questionColumnDefs = [
    { headerName: "Index", valueGetter: "node.rowIndex + 1" }, // Adds 1 to the index to make it 1-based
    { headerName: "Question IDs", field: "value", valueGetter: "data", cellRendererFramework: qIDlink }, // Display the question IDs
    // {
    //   headerName: "Question",
    //   field: "questionPlainText",
    //   width: 200,
    //   filter: true,
    //   tooltipField: "questionPlainText",
    // },
    { headerName: "Actions", field: "actions", cellRendererFramework: button, },
  ];


  const columnDefs = [
    {
      headerName: "Module Name",
      field: "moduleName",
      cellRendererFramework: link,
      filter: true,
    },
    {
      headerName: "Description",
      field: "description"
    },
    {
      headerName: "Question Count",
      field: "questionCount"
    },
    {
      headerName: "Locked",
      field: "locked"
    },
    {
      headerName: "Subject",
      field: "subject",
      filter: true
    },
    {
      headerName: "Chapter",
      field: "chapter",
      filter: true,
    },
    {
      headerName: "Created By",
      field: "createdBy",
      filter: true,
    },
    {
      headerName: "Created Date",
      field: "createdDate",
      valueFormatter: (createdDate) => {
        return createdDate ? moment(createdDate.value).format("DD-MM-YYYY hh:mm A") : '';
      },
      filter: true,
    },
    {
      headerName: "Updated By",
      field: "updatedBy",
      filter: true,
    },
    {
      headerName: "Updated Date",
      field: "updatedDate",
      valueFormatter: (updatedDate) => {
        return updatedDate ? moment(updatedDate.value).format("DD-MM-YYYY hh:mm A") : '';
      },
      filter: true,
    },
  ];

  const gridOptions = {
    columnDefs,
    rowData: selectedTopicsList,
  };

  const onHandleSubjectClick = (e) => {
    setSelectedTopicsList(qbData?.filter(data => data.subject == e.subject));
    setCurrentViewShowing("topic");
  };

  const openAddQuestionModal = () => {
    setOpenAddQnModal(true)
  }

  const handleCloseAddQuestionModal = () => {
    setOpenAddQnModal(false)
  }

  const handleDownload = () => {
    setShowDownloadModal(true);
  }

  const handleDownloadClose = () => {
    setShowDownloadModal(false);
  }

  const handleDownloadQB = () => {
    getInstutueApp(`${apiPaths.downloadQB}?libraryQBId=${selectedQBModuleId}&includeExplanation=${includeExplanation}&includeQuestion=${includeQuestion}&includeAnswer=${includeAnswer}`, null, {
        tenantId: getUserDetails().tenantId,
        userEmail: getUserDetails().email
    }, 'blob')
      .then(async (res) => {
        const blob = new Blob([res.data], { type: res.headers['content-type'] });
        let fileName = "downloaded-file";
        const disposition = res.headers['content-disposition'];
        if (disposition && disposition.includes("filename=")) {
          const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (match != null && match[1]) {
            fileName = match[1].replace(/['"]/g, '');
          }
        }

        // Create download link
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url); // cleanup
      })
      .catch((err) => console.log(err));
  }

  const AddQuestionClick = async () => {
    const response = await postInstituteAppData(apiPaths.addQuestionToQB, {
      data: [],
      params: {
        questionId: addedQuestionId,
        libraryQBModuleId: libraryQBModuleId
      },
      headers: {
        tenantId: getUserDetails().tenantId,
        userEmail: getUserDetails().email,
      },

    })
    handleCloseAddQuestionModal()
    if (response.result == true) {
      Toaster(toast.TYPE.SUCCESS, "Question Id Added Successfully");
      refreshTopicQuestions();
    } else {
      Toaster(toast.TYPE.SUCCESS, "Error in adding question Id");
    }

  }

  const refreshTopicQuestions = () => {
    handleQuestionClick(selectedQBModuleId);
  }

  return (
    <div>
      <h2 className="main-heading">Question Bank</h2>
      {loading && <p>Loading...</p>}
      {filteredSubject?.length === 0 && (
        <Card className={classes.noDataCard}>
          <Box display="flex" justifyContent="center">
            <img src={noData} alt="noData" width="550px"></img>
          </Box>
        </Card>
      )}

      {/* <p style={{ display: "flex", justifyContent: "space-between" }}> */}

      <Button
        variant="outlined"
        style={{
          margin: "10px",
        }}
        disabled={currentViewShowing === "subject"}
        onClick={() => {
          if (currentViewShowing === "topic") {
            setCurrentViewShowing("subject");
          }
        }}
      >
        Back
      </Button>
      {/* </p> */}
      <Gd className="subjects" container spacing={2}>
        {currentViewShowing === "subject" && <>
          {filteredSubject?.map((el, i) => (
            <Gd
              item
              xs={2}
              style={{ cursor: "pointer" }}
              onClick={() => onHandleSubjectClick(el)}
            >
              <Card className={classes.card}>
                <Gd item xs={12}>
                  {el.thumbnailUrl ?
                    <img src={el.thumbnailUrl} alt="classViewImage" width="100%"></img> : <img src={noImage} width="100%" ></img>}

                </Gd>
                <Gd item xs={12}>
                  <CardContent>
                    <Box style={{ minHeight: "40px", maxHeight: "40px" }}>
                      <Typography variant="span" className={classes.title}>
                        {el?.subject}
                      </Typography>
                      <p>{el?.yearTaught}</p>
                    </Box>
                  </CardContent>
                </Gd>
              </Card>
            </Gd>
          ))}</>}
        {currentViewShowing === "topic" && <>
          {!loading && selectedTopicsList && selectedTopicsList.length > 0 && (
            <Grid
              gridOptions={{
                ...gridOptions,
                pagination: true,
                paginationPageSize: 10,
              }}
              parent="qb"
            />
          )}

          {selectedQuestionId && (
            <QuestionViewModal
              open={true}
              handleClose={() => {
                setSelectedQuestionId(null);
                setSelectedQuestionIndex(-1);
                setQuestionData({});
              }}
              selectedQuestionEditable={selectedQuestionEditable}
              isEditEnabled={true}
              prevQuestion={
                selectedQuestionIndex > 0
                  ? questionDataList[selectedQuestionIndex - 1]
                  : null
              }
              nxtQuestion={
                selectedQuestionIndex < questionDataList.length - 1
                  ? questionDataList[selectedQuestionIndex + 1]
                  : null
              }
              questionData={questionData}
              QBCount={QBCount}
              selectedQuestion={selectedQuestionId}
              setId={(e) => {
                setSelectedQuestionId(e);
                setSelectedQuestionIndex(questionDataList.indexOf(e));
                // Fetch question data for the clicked question ID
                getData(apiPaths.questionbyid + `?id=${e}`).then((response) => {
                  if (response.result) {
                    setQuestionData(response.result);
                  }
                });
              }}
            />
          )}

          {questionDataList.length > 0 && (
            <>

              <h2>Question Data
                <span>
                  <Button variant="contained" onClick={openAddQuestionModal} style={{ marginLeft: "30px" }}>Add Question Id</Button>
                </span>
                <span>
                  <Button variant="contained" onClick={handleDownload} style={{ marginLeft: "30px" }}>Download</Button>
                </span>
              </h2>
              <Grid
                gridOptions={{
                  columnDefs: questionColumnDefs,
                  rowData: questionDataList,
                  pagination: questionDataList.length > 10,
                  paginationPageSize: 10,
                }}
                parent="questionData"

              />

            </>
          )}
        </>}

      </Gd>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Make sure you remove every link to the question—in both the question bank and any tests—before you delete it. Question Id: <strong>{deletedQnId}</strong> ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose}>Close</Button>
          <Button variant="contained"
            onClick={handleDeleteQuestion} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openAddQnModal}
        onClose={handleCloseAddQuestionModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Add Question Id<CloseIcon className="close-icon" onClick={handleCloseAddQuestionModal} /></DialogTitle>
        <DialogContent style={{ paddingTop: "10px" }}>
          <DialogContentText id="alert-dialog-description">
            <div class="">
              <TextField
                id="outlined-basic"
                label="Question Id"
                placeholder="Question Id"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                size="small"
                value={addedQuestionId}
                style={{ width: "100%" }}
                onChange={(item) => {
                  setAddedQuestionId(item.target.value);
                }}
              />
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button variant="contained" color="error" onClick={handleCloseAddQuestionModal}>Close</Button> */}
          <Button variant="contained" onClick={AddQuestionClick} autoFocus>Add</Button>
        </DialogActions>
      </Dialog>
      <Modal open={showDownloadModal} onClose={handleDownloadClose} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Box sx={{ p: 2, width: 400, backgroundColor: '#fff', borderRadius: '4px', boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.15)' }}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Download QB
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={includeExplanation}
                onChange={(e) => setIncludeExplanation(e.target.checked)}
              />
            }
            label="Include Explanation"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={includeAnswer}
                onChange={(e) => setIncludeAnswer(e.target.checked)}
              />
            }
            label="Include Answer"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={includeQuestion}
                onChange={(e) => setIncludeQuestion(e.target.checked)}
              />
            }
            label="Include Question"
          />
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant="contained" onClick={handleDownloadQB}>
              Download
            </Button>
            <Button variant="outlined" sx={{ ml: 2 }} onClick={handleDownloadClose}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>

  );

};

export default Qb;
